/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Terms_RequiredInputs */

const es_ab_err_terms_required = /** @type {(inputs: Ab_Err_Terms_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes aceptar los términos y la política de privacidad para continuar`)
};

const gl_ab_err_terms_required = /** @type {(inputs: Ab_Err_Terms_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes aceptar os termos e a política de privacidade para continuar`)
};

const en_ab_err_terms_required = /** @type {(inputs: Ab_Err_Terms_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must accept the terms and privacy policy to continue`)
};

/**
* | output |
* | --- |
* | "You must accept the terms and privacy policy to continue" |
*
* @param {Ab_Err_Terms_RequiredInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_terms_required = /** @type {((inputs?: Ab_Err_Terms_RequiredInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Terms_RequiredInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_terms_required(inputs)
	if (locale === "en") return en_ab_err_terms_required(inputs)
	return es_ab_err_terms_required(inputs)
});